import DefaultLayout from "@/layouts/DefaultLayout";
import WorkOrderDeleteDialog from "kinnect-front/FacilityMaintenance/WorkOrders/WorkOrderDeleteDialog";
import WorkOrderForm from "kinnect-front/FacilityMaintenance/WorkOrders/WorkOrderForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { FacilityMaintenanceWorkOrder } from "kinnect-models";

export default {
	name: "FacilityMaintenanceWorkOrderPage",

	metaInfo() {
		const title = this.editing
			? "Facility Maintenance - View Work Order"
			: "Facility Maintenance - Add Work Order";

		return { title };
	},

	props: { idWorkOrder: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "facility_maintenance_work_orders",
		deleteDialogOpen: false,
		workOrder: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idWorkOrder );
		},

		genDeleteDialog() {
			if ( this.editing && this.workOrder && this.canDelete ) {
				return <WorkOrderDeleteDialog
					item={this.workOrder}
					onConfirm={() => this.workOrder.delete()}
					redirect={[ "back", { name: "facilityMaintenanceWorkOrders" } ]}
					vModel={this.deleteDialogOpen}
				></WorkOrderDeleteDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this work order"
				};
			}
		}
	},

	methods: {
		async fetchWorkOrder() {
			if ( this.editing ) {
				this.workOrder = await FacilityMaintenanceWorkOrder
				.include( [
					"location",
					"statuses",
					"vendor"
				] )
				.findPageModel( this.idWorkOrder );
			}
		},

		async fetch() {
			await this.fetchWorkOrder();
		}
	},

	render() {
		return <DefaultLayout>
			<WorkOrderForm
				loading={this.$wait.is( "find work order" )}
				readonly={this.editing ? !this.canEdit : false}
				workOrder={this.workOrder}
			></WorkOrderForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
